import * as ToastActionTypes from '../../actions/toasts/types';

export function toastsReducer(state = [], action) {
    switch (action.type) {
        case ToastActionTypes.ADD: {
            const notification = action.payload;

            return [...state, notification.id];
        }

        case ToastActionTypes.REMOVE: {
            const notification = action.payload;

            return state.filter((id) => id !== notification.id);
        }

        default:
            return state;
    }
}
